"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentName = exports.SiteVerificationMethod = exports.AccountDetailsCollectionName = exports.ChatServiceNameEnum = void 0;
var ChatServiceNameEnum;
(function (ChatServiceNameEnum) {
    ChatServiceNameEnum["LiveChat"] = "livechat";
    ChatServiceNameEnum["Zendesk"] = "zendesk";
    ChatServiceNameEnum["Tawk"] = "tawk";
})(ChatServiceNameEnum || (exports.ChatServiceNameEnum = ChatServiceNameEnum = {}));
var AccountDetailsCollectionName;
(function (AccountDetailsCollectionName) {
    AccountDetailsCollectionName["Phone"] = "phone";
    AccountDetailsCollectionName["Email"] = "email";
    AccountDetailsCollectionName["BirthDate"] = "birth_date";
    AccountDetailsCollectionName["Identity"] = "identity";
    AccountDetailsCollectionName["Address"] = "address";
    AccountDetailsCollectionName["BankDetails"] = "bank_details";
})(AccountDetailsCollectionName || (exports.AccountDetailsCollectionName = AccountDetailsCollectionName = {}));
var SiteVerificationMethod;
(function (SiteVerificationMethod) {
    SiteVerificationMethod["PersonalDetails"] = "personal_details";
    SiteVerificationMethod["Document"] = "document";
    SiteVerificationMethod["Address"] = "address";
    SiteVerificationMethod["PaymentProof"] = "payment_proof";
})(SiteVerificationMethod || (exports.SiteVerificationMethod = SiteVerificationMethod = {}));
var DocumentName;
(function (DocumentName) {
    DocumentName["NationalIdCard"] = "national_id_card";
    DocumentName["InternationalPassport"] = "international_passport";
    DocumentName["DriverLicense"] = "driver_license";
})(DocumentName || (exports.DocumentName = DocumentName = {}));
//# sourceMappingURL=siteConfigEnums.js.map